import {api} from "../../services";
import io from "socket.io-client";
import Swal from "sweetalert2";

const baileys_integration = {
  state: {
    id_integration: null, 
    data: {},
    changing_session: true,
    is_production: false,
    channel_id: null,
    url_deploy: null,
    // srv_baileys1: [
    //   'ruralwebt.wmelon.online',
    //   'idellimpeza.wmelon.online',
    //   'shoppinglitoralsul.wmelon.online',
    //   'dodiasupermercados.voxxell.com',
    //   'comercialesperanca.voxxell.com',
    //   'superdonadecasa.voxxell.com',
    //   'casadofazedor.beecrm.io',
    // ],
    url_api_baileys: null,
    socket_baileys: null,
    qrcode_url: null,
    existing_connection: false,
    session_state: false,
  },
  mutations: {
    // SET_ANY_MUTATION(state, payload) {
    //   state.data = payload
    // },
  },
  getters: {
  },
  actions: {
    // FAZ AS VERIFICAÇÕES INICIAIS QUANDO ENTRA NA TELA DE EDIÇÃO DO CANAL
    verifyWhatIsTheUrlBaileys(context) {
      const isProduction = document.URL.split('/')[0] == 'https:';
      const url_deploy = isProduction
        ? document.URL.split('/')[2]
        : 'dev.localhost.io'
      context.state.url_deploy = url_deploy;

      // if (context.state.srv_baileys1.includes(`${url_deploy}`)) {
      //   context.state.url_api_baileys = 'srvbaileys1.beecrm.io';
      // } else {
      //   context.state.url_api_baileys = 'lemmonbaileys.beecrm.io';
      // }
      context.state.url_api_baileys = 'spinoza.beecrm.io';
    },

    // VERIFICA SE EXISTE SESSÃO
    verifyIfSessionExists(context, payload) {
      const isProduction = document.URL.split('/')[0] == 'https:';
      const url_deploy = isProduction
        ? document.URL.split('/')[2]
        : 'dev.localhost.io'
      const id_integration = context.state.id_integration;

      // api.post(`https://${url_deploy}/api/v1/channels/integrations/11/actions/connection_state`, {
      api.post(`/channels/integrations/${id_integration}/actions/connection_state`, {
        channel_id: payload.id
      })
        .then((response) => {
          context.state.session_state = response.data.action_return.state;

        if(context.state.session_state === 'connecting' || context.state.session_state === 'connecting') {
          // api.post(`https://${url_deploy}/api/v1/channels/integrations/11/actions/connect`, {
          api.post(`/channels/integrations/${id_integration}/actions/connect`, {
            channel_id: payload.id
          }).then((response) => {
            context.state.qrcode_url = `${response.data.action_return.base64}`
            context.state.changing_session = false
          })
        }
      }).catch((error) => {
        context.state.changing_session = true

        if(error.response && (error.response.status === 404 || error.response.status === 403 || error.response.status === 500)) {
          context.state.session_state = 'close';
          // this.dispatch('connectSession', payload)
        }
      })
    },

    // connecting -> não leu ainda
    // open -> conectado
    // close -> desconectado

    // CRIAR UMA NOVA SESSÃO
    connectSession(context, payload){
      context.state.changing_session = true

      const isProduction = document.URL.split('/')[0] == 'https:';
      const url_deploy = isProduction
        ? document.URL.split('/')[2]
        : 'dev.localhost.io'
      context.state.url_deploy = url_deploy;
      const id_integration = context.state.id_integration;

      const requestData = {
        channel_id: payload.id,
      }

      // api.post(`https://${url_deploy}/api/v1/channels/integrations/11/actions/create_connection`, requestData)
      api.post(`/channels/integrations/${id_integration}/actions/create_connection`, requestData)
        .then((response) => {
          context.state.qrcode_url = `${response.data.action_return.base64}`
          context.state.changing_session = false
        }).catch(error => {
          // context.state.changing_session = false

        if(error.response) {
          api.post(`/channels/integrations/${id_integration}/actions/connect`, requestData)
            .then((response) => {
            context.state.qrcode_url = `${response.data.action_return.base64}`
            context.state.changing_session = false
          })
        }
        })
    },

    // DELETA UMA SESSÃO
    disconnectSession(context, payload) {
      context.state.changing_session = true
      const isProduction = document.URL.split('/')[0] == 'https:';
      // const url_deploy = isProduction
      //   ? document.URL.split('/')[2]
      //   : 'dev.localhost.io'
      const url_deploy = context.rootState.configs.current_url;
      context.state.url_deploy = url_deploy;

      api.delete(`https://${context.state.url_api_baileys}/instance/logout/${payload.id}-${url_deploy}`, {
        headers: {
          'Content-Type': 'application/json',
          'apikey': `429683C4C977415CAAFCCE10F7D57E11`
        }
      }).then(() => {
        api.delete(`https://${context.state.url_api_baileys}/instance/delete/${payload.id}-${url_deploy}`, {
          headers: {
            'Content-Type': 'application/json',
            'apikey': `429683C4C977415CAAFCCE10F7D57E11`
          }
        }).then(() => {
          context.state.changing_session = false
          context.state.session_state = 'close'
        })
      })
    },

    // SALVA AS INFORMAÇÕES DE SESSÃO NO BACKEND
    setSessionInBackend(context, infos){
      api.post(`/channels/set-session-baileys/${context.state.channel_id}`, infos)
        .then((response) => {
          context.rootState.channels.channel = response.data
          context.rootState.channels.integration = response.data.integrations[11]
          context.rootState.channels.qrcode_url = null
        });
    },

  },
}
export default baileys_integration;
